import { Injectable } from '@angular/core';
import { Logger } from './logger';

@Injectable()
export class LoggerService implements Logger {
  info: any;

  warn: any;

  error: any;

  captureError(error: Error): void { console.error(error); }
}
